export default __webpack_public_path__ + "static/media/image_31-901.f0fd5b62.png";